ACC.cartpopup = {

	bindAll: function ()
	{
		this.bindCartPop();
	},

	bindCartPop: function () {

		var $rolloverCartPopup 	= $('#rollover_cart_popup'),
			$shopContent 		= $('#div_shopping_bag_top'),
			rolloverIsHovered	= false,
			cartIsHovered 		= false;

		$rolloverCartPopup.hide();

// 	TODO move the 'hover' event into these on assigners

		$shopContent.on({

			mouseenter : function () {

				$('#cart_popup').hide();
				$.ajax({
					url: rolloverPopupUrl,
					cache: false,
					type: 'GET',
					success: function (result)
					{
						$rolloverCartPopup.html(result).fadeIn();
					}
				});

				cartIsHovered = true;
			},

			mouseleave : function () {

				setTimeout(function () {
					if (!cartIsHovered && !rolloverIsHovered)
					{
						$rolloverCartPopup.fadeOut();
					}
				}, 100);

				cartIsHovered = false;
			}

		});




		$(document).on('click', '#ajax_cart_close', function (e) {
			e.preventDefault();
			$rolloverCartPopup.hide();
		});


		$rolloverCartPopup.on({

			mouseenter : function () {
				$rolloverCartPopup.show();
				rolloverIsHovered = true;
			},

			mouseleave : function () {
				
				setTimeout(function () {
					if (!cartIsHovered && !rolloverIsHovered)
					{
						$rolloverCartPopup.fadeOut();
					}
				}, 100);

				rolloverIsHovered = false;
			}

		});

	},

	refreshMiniCart : function()
	{
		$.get(refreshMiniCartUrl + Math.floor(Math.random() * 101) * (new Date().getTime()), function (result)
		{
			$('#minicart_data').html(result)
		});
	}
};

$(document).ready(function ()
{
	ACC.cartpopup.bindAll();
});

